import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/components/ui/breadcrumb'
import { Link, useLocation } from 'react-router-dom'
import { Fragment } from 'react/jsx-runtime'
import { paths } from '@/config/paths'
import { PageTitle } from './pageTitle'

export type BreadcrumbPath = {
  title: string
  to?: string
}

type PageTitleProps = {
  title?: string
  path?: BreadcrumbPath[]
}

const PageHeader = ({ title, path }: PageTitleProps) => {
  const location = useLocation()
  const isGlobalMode = location.pathname.startsWith(paths.admin.root.getHref())

  return (
    <div className="flex justify-between items-center">
      <PageTitle title={title} />
      <Breadcrumb className="hidden sm:block">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to={isGlobalMode ? paths.admin.dashboard.getHref() : paths.app.dashboard.getHref()}>Home</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          {path?.map((pathPart) => (
            <Fragment key={pathPart.title}>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                {pathPart.to ? (
                  <BreadcrumbLink asChild>
                    <Link to={pathPart.to}>{pathPart.title}</Link>
                  </BreadcrumbLink>
                ) : (
                  <BreadcrumbPage>{pathPart.title}</BreadcrumbPage>
                )}
              </BreadcrumbItem>
            </Fragment>
          ))}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  )
}

export { PageHeader }
